import { isUndefined } from 'lodash';
import { largeCurrencyFormat } from 'common/formats/formats';
import { Currency } from 'common/types/format';
import formatNumbers from 'utilities/formatNumbers';

interface FormatCurrency {
  currency?: Currency;
  style: string;
  validateFloat: boolean;
  minimumFractionDigits: number;
  maximumFractionDigits: number;
}

export const returnCurrencyFormattedValueOrNull = (
  value: number,
  format: FormatCurrency,
  exchangeRate: string,
  isCaptableCurrencyApproach: boolean
) => {
  const currency = {
    ...(format?.currency || {}),
    exchangeRate: isCaptableCurrencyApproach ? '1' : exchangeRate,
  };

  // Passing default values for the props that are required in formatNumbers
  return !isUndefined(value)
    ? `${formatNumbers({
      value,
      currency,
      format: largeCurrencyFormat,
      prefix: '',
      suffix: '',
      allowNegativeValue: true,
      currencyCode: currency.code,
      blankIfNull: false,
      staticCurrency: false,
    })}`
    : null;
};
